/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDeviceGroupDto } from '../../models/create-device-group-dto';
import { DeviceGroupDto } from '../../models/device-group-dto';

export interface DeviceGroupControllerCreate$Params {
  clientWorkspaceId: string;
      body: CreateDeviceGroupDto
}

export function deviceGroupControllerCreate(http: HttpClient, rootUrl: string, params: DeviceGroupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerCreate.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceGroupDto>;
    })
  );
}

deviceGroupControllerCreate.PATH = '/api/device-group/{clientWorkspaceId}';
